import React, { useState } from "react";
import { FaReact, FaHtml5 } from "react-icons/fa";
import charum from "../assets/image/charum.png";
import bayeue from "../assets/image/bayeue.png";
import plat from "../assets/image/data-plat.png";

const ReadMore = ({ children }) => {
  const [isReadMore, setIsReadMore] = useState(true);
  const text = children;
  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };
  return (
    <p className="text">
      {isReadMore ? text.slice(0, 150) : text}
      <span
        onClick={toggleReadMore}
        className="read-or-hide text-gray-200 cursor-pointer hover:text-white"
      >
        {text.length > 150
          ? isReadMore
            ? " ...Read more"
            : " ...Show less"
          : ""}
      </span>
    </p>
  );
};

const Skills = () => {
  return (
    <div className="container mx-auto px-4 flex flex-col ">
      <div className="header-skills">
        <p
          style={{ fontSize: "42px", fontWeight: "bold" }}
          className="py-8 px-10 cursor-default"
        >
          Skills
        </p>
      </div>
      <div className="body-skills flex flex-wrap justify-center gap-20 lg:gap-40 md:gap-20 max-sm:gap-10">
        <div className="skiil">
          <FaReact className="text-7xl" />
          <h1 className="pt-3 text-xl font-semibold text-center cursor-default">
            ReactJS
          </h1>
        </div>
        <div className="skiil">
          <FaHtml5 className="text-7xl" />
          <h1 className="pt-3 text-xl font-semibold cursor-default">HTML</h1>
        </div>
        <div className="skiil">
          <i class="fa-brands fa-golang text-7xl"></i>
          <h1 className="pt-3 text-xl font-semibold cursor-default">Golang</h1>
        </div>
        <div className="skiil">
          <i class="fa-brands fa-laravel text-7xl"></i>
          <h1 className="pt-3 text-xl font-semibold cursor-default">Laravel</h1>
        </div>
      </div>
      <div className="mt-20 portfolio justify-center flex gap-10 flex-wrap">
        <div className="py-10 flex flex-col w-4/5 lg:w-2/5 md:w-3/4 max-sm:w-full items-center">
          <img src={bayeue} alt="bayeue" />
          <p className="mt-10 font-bold text-3xl">Bayeue</p>
          <div className="list-tech flex mt-5 gap-5">
            <i class="fa-brands fa-golang text-4xl"></i>
            <i class="fa-brands fa-vuejs text-4xl"></i>
          </div>
          <p className="font-semibold text-justify mt-3">
            <ReadMore>
              In 4 months I learned about GitHub, Go basics, build APIs with the
              Go framework Echo, learn the MVC code structure and clean
              architecture, learn unit testing, learn Docker container, and
              learned professional soft skills. And in last program at the MSIB
              program with Alterra Academy. Within a month and a half we built
              the capstone project and named it "Bayeue application" with the
              PPOB topic. From here, I learned project management like a real
              cases and how to manage time effectively.
            </ReadMore>
          </p>
          <a
            style={{ width: "75px" }}
            className="link-btn p-1 mt-3 rounded-lg hover:bg-white hover:text-green-700 cursor-pointer bg-green-700"
            href="https://bayeue.vercel.app/landing"
            target="_blank"
            rel="noreferrer"
          >
            Link
          </a>
        </div>
        <div className="py-10 w-1/2 lg:w-2/5 md:w-3/4 max-sm:w-full flex flex-col items-center">
          <img src={charum} alt="charum" />
          <p className="mt-10 font-bold text-3xl">Charum</p>
          <div className="list-tech flex mt-5 gap-5">
            <i class="fa-brands fa-golang text-4xl"></i>
            <i class="fa-brands fa-react text-4xl"></i>
          </div>
          <p className="font-semibold text-justify mt-3">
            <ReadMore>
              The primary objective of the Bayeue project is the development of
              a comprehensive application that serves as a platform for group
              discussions on a variety of topics. As the team leader, it is my
              responsibility to oversee the progress of the project and to
              ensure the effective integration of React JS. The ultimate aim is
              to deliver a user-friendly and efficient forum for group
              discussions through the Bayeue application. This platform will
              provide users with an opportunity to engage in meaningful
              conversations and exchange ideas and viewpoints with their peers.
            </ReadMore>
          </p>
          <a
            style={{ width: "75px" }}
            className="link-btn p-1 mt-3 rounded-lg hover:bg-white hover:text-green-700 cursor-pointer bg-green-700"
            href="https://charum-fgd.vercel.app/"
            target="_blank"
            rel="noreferrer"
          >
            Link
          </a>
        </div>
        <div className="py-10 w-1/2 lg:w-2/5 md:w-3/4 max-sm:w-full flex flex-col items-center">
          <img src={plat} alt="charum" />
          <p className="mt-10 font-bold text-3xl">Data Plat UNIKOM</p>
          <div className="list-tech flex mt-5 gap-5">
            <i class="fa-brands fa-laravel text-4xl"></i>
            <i class="fa-brands fa-react text-4xl"></i>
          </div>
          <p className="font-semibold text-justify mt-3">
            <ReadMore>
              This application was created using Laravel as the backend Rest API
              and react js for the frontend. It allows for the management of
              data plates, including the ability to create new ones, read and
              display existing ones, update their information, and delete them
              as needed. In addition, I implemented the use of socket.io to
              establish a connection with an RFID detector, allowing for
              real-time communication and updates within the application.
            </ReadMore>
          </p>
          <a
            style={{ width: "75px" }}
            className="link-btn p-1 mt-3 rounded-lg hover:bg-white hover:text-green-700 cursor-pointer bg-green-700"
            href="https://github.com/gozzafadillah/plat-parkiran-rebuild"
            target="_blank"
            rel="noreferrer"
          >
            Link
          </a>
        </div>
      </div>
    </div>
  );
};

export default Skills;
